const Form010TC = {
    stepName: {
        ImportantNotes: "事項",
        FormExpired: "事項",
        Application: "申請訊息",
        AcademicDetails: "學業概況和校內服務",
        LanguageProficiency: "語言能力, 興趣及才藝",
        TravelingExperience: "旅遊經驗",
        FurtherInformation: "其他資料",
        Declaration: "聲明",
        Consent: "家長 / 監護人同意書",
        FormA: "甲部",
        FormB: "推薦",
        SectionB: "乙部 及 丙部",
        SectionD: "丁部",
        SectionE: "戊部 及 己部",
        SectionG: "庚部",
        SectionH: "辛部 及 壬部",
        SectionJ: "癸部 及 事項",
        Confirmation: "確認",
    },
    title: {
        note: "注意",
        collectionPersonal: "個人資料收集",
        languageProficiency: "(D) 語言能力",
        employment: "工作",
        personalParticulars: "(A) 個人資料",
        hkPersonTitle: "居港聯絡人資料",
        exchangeProgramme: "交流計劃",
        exchangeProgrammeTitle: "你過去曾否帶領其他學生交流計劃？",
        exchangeProgrammeTableTitle: "若有，請提供有關資料",
        InterestsAndHobbies: "興趣及嗜好",
        InterestsAndHobbiesTableTitle:
            "請填上你的興趣及嗜好，若有需要，可附上有關證明：",
        part2: "第二部分",
        part2title: "推薦 - 由提名學校的校長填寫",
        undertakeTitle: `本人明白學生代表及隨團教師的選拔是獨立處理的。一旦獲提名學生入選，不論同樣獲本人提名參加「計劃」的教師（如有）是否獲選，本人承諾讓該生於{{undertakeDate}}期內參加交流團。本人將敦促他 / 她出席所有活動及在外訪期間敦品勵行。`,
        academicDetails: "(B) 學業概況",
        responsibilitiesInSchool: "(C) 校內服務",
        interestsTalents: "(E) 興趣及才藝",
        questions: "(G) 請回答下列問題",
        TravelingExperience: "(F) 旅遊經驗",
        FurtherInformation: "(H) 其他資料",
        Declaration: "(I) 聲明",
        Consent: "(J) 家長 / 監護人同意書",
        consentTitle: `本人同意敝子弟參加「計劃」，並承諾一旦他 / 她獲選，定當督促他 / 她履行(I)段列出的責任及義務。`,
    },
    label: {
        japanese: "日語",
        english: "英文",
        putonghua: "普通話",
        proficiencyOptions: {
            fluent: "流利",
            canExpress: "略懂",
            cannotSpeak: "不懂",
        },
        remarks: "備註",
        canSpeakJapanese: "(a) 語言程度",
        everLearntJapanese: "(b) 你有否進修日語課程？",
        outstandingPerformance:
            "(c) 在普通話及／或英語方面，你有否突出表現？(如考獲國家語委普通話水平測試二級乙等或以上成績、國際英語水平測試(IELTS)整體成績為6級或以上)",
        outstandingPerformance1: "國際英語水平測試(IELTS)整體成績為6級或以上)",
        everLearntJapaneseOptions: {
            yes: "有",
            no: "没有",
        },
        learntJapaneseNote: "若有，請提供有關資料，並附上有關證明文件副本：",
        courseName: "課程名稱",
        attainedLevel: "獲取程度",
        startDate: "開始日期",
        completeDate: "完結日期",
        schoolName: "學校名稱",
        schoolAddress: "學校地址",
        schoolTel: "電話",
        schoolFax: "傳真",
        positionHeld: "職位",
        positionHeldOptions: {
            assistantPrincipal: "副校長",
            seniorTeacher: "主任",
            teacher: "教師",
        },
        presentSchoolDate: "到校任教的日期",
        presentPostDate: "出任現職的日期",
        taughtTitle: "本學年任教高中的科目",
        taughtSubject: "任教科目",
        taughtLevel: "任教級別",
        taughtRemarks: "附註",
        headTitle: "非教學工作 （班主任 / 學會顧問 / 課外活動統籌等）",
        headPosition: "職位",
        natureOfDuty: "職務",
        period: "期間",
        headRemarks: "附註",
        experienceTitle: "其他工作經驗 （包括非教學經驗及海外的工作經驗）",
        instituteName: "學校 / 院校機構",
        nameRemark: "姓名(請依香港特別行政區護照所示填寫)",
        englishName: "英文",
        chineseName: "中文",
        chineseCodeName: "姓名(中文姓名電碼)",
        birthDate: "出生日期",
        birthPlace: "出生地點",
        sex: "性别",
        hkIDNo: "香港身份證號碼",
        homeAddress: "住址",
        photoAttachment: "請上載照片",
        homeTel: "聯絡電話號碼",
        mobilePhone: "流動電話",
        eMailAddress: "電郵地址",
        faxNo: "傳真號碼",
        hkSARPassportNumber: "你是否持有有效的香港特別行政區護照？",
        expiryDate: "屆滿日期",
        issueDate: "簽發日期",
        sexOption: {
            Male: "男",
            Female: "女",
        },
        hkPersonEnName: "姓名(英文)",
        hkPersonCnName: "姓名(中文)",
        hkPersonRelationship: "與獲提名人的關係",
        hkPersonAddress: "地址",
        hkPersonHomeTel: "聯絡電話號碼",
        hkPersonMobliePhone: "流動電話",
        hkPersonEmail: "電郵地址",
        hkPersonFax: "傳真",
        exchangeProgrammePeriod: "期間",
        exchangeProgrammeHostingOrganization: "主辦機構",
        exchangeProgrammePlace: "曾經到訪的地區 / 國家",
        exchangeProgrammePurpose: "該行目的",
        exchangeProgrammeHostingRole: "你的職責",
        interestsOrHobbies: "興趣 / 嗜好",
        achievements: "成績（相關紀錄，如有）",
        gotFirstAidTraining: "你過去曾否接受急救訓練？",
        gotFirstAidTrainingTitle:
            "若有，請列出急救證書的有效日期，並附上有關的證明。",
        firstAidCertificateExpiryDate: "急救證書的有效日期(日 / 月 / 年)",
        trainUpStudentDelegatesArea:
            "請列出你能訓練學生代表的範疇，例如：簡單日語、演講、合唱等",
        supportingApplicationInformation:
            "請列出其他有助你申請的資料，如曾任日語翻譯等",
        attendActivities:
            "(a) 一旦獲選，你能否出席安排於星期六、日早上 / 下午及週日午後 / 黄昏舉行的活動？",
        attendActivitiesOptions: {
            yes: "可以",
            no: "不可以",
            notSure: "不肯定",
        },
        nomineeName: "獲提名人姓名",
        nominationReasons: "本人的提名是基於下列原因",
        principalName: "校長姓名",
        contactTel: "聯絡電話號碼",
        academicDetailsSchoolName: "學校名稱",
        academicDetailsSchoolAddress: "學校地址",
        academicDetailsLevel: "年級",
        electiveSubject: "選修科目：",
        examinationReports: "請夾附中四最後兩次考試成績表副本。",
        responsibilitiesPeriod: "期間",
        studentUnion: "學生會/ 學會/ 會社",
        post: "崗位",
        experiencesBenefit: "上述經驗對你有何裨益？",
        examinationName: "考試 / 比賽名稱",
        levelAttained: "獲取程度",
        completionDate: "完成日期 / 獲獎日期",
        interestsOrTalents: "興趣 / 才藝",
        interestsOrTalentsAchievements: "成績（相關紀錄，如有）",
        interestsOrTalentsAttachment:
            "請填上你的興趣及才藝，並附上有關證明文件副本，如有：",
        countryVisited: "前往國家",
        travelingPeriodFrom: "由",
        travelingPeriodTo: "至",
        travelingTimes: "次數 (截至{{travelingTimes}})",
        travelingPurpose: "目的（例如：觀光、交流、服務）",
        interestedProgramme: "(a) 你為何有興趣參加「計劃」？",
        expectProgramme: "(b) 你期望從「計劃」中可獲得甚麽？",
        shareExperience: "(c) 你打算於外訪後如何與同儕分享此行的體驗？",
        appliedActivities:
            "(b) 你有否申請 / 獲取錄參加於{{appliedTime}}期間舉行的其他交流計劃及 / 或類近的活動？",
        provideInformation: "(i) 若有，請提供有關資料。",
        appliedActivitiesPeriod: "期間",
        appliedActivitiesProgramme: "活動名稱",
        appliedActivitiesOrganization: "舉辦機構",
        appliedActivitiesRemarks: "備註",
        appliedActivitiesRemarksOptions: {
            underApplication: "正在申請",
            admitted: "已獲取錄",
        },
        giveUpProgramme:
            "(ii) 如果你獲選參加「計劃」，你是否會／可以放棄於同一時期舉行的交流計劃？",
        giveUpProgrammeOptions: {
            yes: "是",
            no: "否",
        },
        parentName: "家長 / 監護人姓名",
        nomineeRelationship: "與獲提名人的關系",
        parentSign: "家長 / 監護人簽署",
        pleaseContact: "如對是次提名有任何查詢，可聯絡",
        teacherName: "負責老師姓名",
        teacherSexOptions: {
            Mr: "先生",
            Ms: "女士",
        },
        nomineeSign: "獲提名人簽署",
        approverEmailAddress: "電郵地址",
        hasPassNoTips: "若有，請提供香港特別行政區護照屆滿日期",
        passNoExpireDate: "香港特別行政區護照屆滿日期(日／月／年)",
    },
    options: {
        hasPassNoOp: {
            yes: "有",
            no: "沒有",
        },
    },
    errorMsg: {
        englishName: "英文姓名",
        chineseName: "中文姓名",
        appliedActivitiesPeriod: "請輸入2025年11月至12月之間的日期",
    },
    note: {
        note1: "(a) 學校須於<b>{{deadline}}</b>遞交提名表格及相關文件。學校可透過統一登入系統(https://clo.edb.gov.hk/)遞交填妥的提名表格，並上載所需證明文件。",
        note2: "(b) 本表格內的資料將用於處理「計劃」的申請。",
        note3: `(c) 獲提名人須上載照片壹張於本表格上。`,
        note4: "(d)	如未能提供所需資料／文件，可能引致申請不獲接納。",
        note5: "(1)	教育局會用本表格所載的個人資料，作以下其中一種或多種用途：",
        note6: "(a)	辦理21世紀東亞青少年大交流計劃的申請；及",
        note7: "(b)	進行有關的研究及編製統計資料，以便規劃有關的教育服務。",
        note8: "(2)	你必須在本表格上填寫個人資料，如不能提供這些資料，申請的處理工作及結果或會受影響。",
        note9: "(3)	本表格所蒐集的個人資料，或會向其他政府部門 / 決策局或接待機構披露，作上文所述用途。",
        note10: "(4) 根據《個人資料（私隱）條例》第18和22條及附表1第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        note11: "(5) 如欲查詢有關本表格所蒐集的個人資料，包括要查閱及改正資料事宜，請向教育局延伸支援計劃組提出，地址為香港灣仔皇后大道東213號胡忠大廈11樓1141室 （電話號碼：2892 6663）。",
        note12: "(a) 本人聲明，上述所填報的資料均屬真確無訛。",
        note13: "(b) 本人承諾一旦獲選，定當：",
        note14: "作為學生代表，敦品勵行、嚴守紀律，並履行一切相關的責任及義務；",
        note15: "出席所有出發前的會議、訓練、簡介會及綵排活動等，並明白一旦缺席上述任何活動，作為代表團成員的資格可被取消；",
        note16: "製訂有關香港的資料以備向接待機構講解；",
        note17: "在外訪期間參與才藝表演；",
        note18: "於外訪結束後完成此行的個人評估表；",
        note19: "於外訪結束後一個半月內完成有關交流成果的小組報告；及",
        note20: "應教育局及 / 或贊助機構的邀請或要求，出席相關活動。",
        note21: "填妥的提名表格須連同下列文件一並提交：",
        note22: "(a) 正面半身近照一張；",
        note23: "(b) 中四最後兩次考試成績表副本；",
        note24: "(c) 通曉 / 學習日語的證明文件副本，如有；及",
        note25: "(d) 普通話及 / 或英語有突出表現的證明文件副本，如有。",
    },
    button: {
        submit: "填寫表格",
        sign: "家長簽署",
    },
};

export default Form010TC;

